// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"6f56ae0b","498":"03cfbf6b","513":"7ffc5253"}[chunkId] + ".chunk.js";
};